import zIndex from '@mui/material/styles/zIndex';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Row, Col, Container, Card, Spinner, Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { getToken } from '../../../utils/auth';

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);
  const [customerID, setCustomerID] = useState();
  const [selectedOrder, setSelectedOrder] = useState(null); // To track the selected order
  const [showModal, setShowModal] = useState(false); // To control modal visibility
  const { t, i18n } = useTranslation();

  const modalStyles = {
    display: showModal ? 'flex' : 'none',
    position: 'fixed',
    justifyContent: 'center',
    alignItems: 'center',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex: 9999,
  };

  const modalDialogStyles = {
    backgroundColor: '#fff',
    padding: '20px',
    maxHeight:"80vh",
    overflowY:"auto",
    borderRadius: '8px',
    maxWidth: '600px',
    width: '100%',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  };

  const closeButtonStyles = {
    background: 'none',
    border: 'none',
    fontSize: '1.5rem',
    cursor: 'pointer',
    position: 'absolute',
    top: '10px',
    right: '20px',
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };


  const fetchUserData = async () => {
    try {
      const token = getToken();
      const response = await axios.get(`${process.env.REACT_APP_URL}/api/user`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setCustomerID(response.data.data.customerId);
    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const handleAllOrders = async () => {
    try {
      const authHeader = 'Basic YWRtaW46aTVJTyA5aEZyIGFIU00gOUtVVCBuc2pYwqBRTm9w';
      const response = await axios.get(
        `${process.env.REACT_APP_URL_ECOMMERCE}/wp-json/wc/v3/orders?customer=${customerID}`, {
          headers: {
            'Authorization': authHeader,
          },
        }
      );

      setOrders(response.data);
    } catch (error) {
      console.error('Failed fetching orders', error);
      setError('Failed fetching orders');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if(customerID){
    handleAllOrders();
    }
  }, [customerID]);

  // Function to handle order selection and open the modal
  const handleViewOrder = (order) => {
    setSelectedOrder(order); // Set the clicked order
    setShowModal(true); // Open the modal
  };

  return (
    <>
      <div id="content-page" className="content-page">
        <Container>
          <Row>
            <Col sm="12">
              <Card>
                <Card.Header className="d-flex justify-content-between">
                  <div className="header-title">
                    <h4 className="card-title">{t('all_orders')}</h4>
                  </div>
                </Card.Header>
                <Card.Body>
                    {/* Display loading spinner while fetching data */}
                    {loading ? (
                      <div className="text-center">
                        <Spinner animation="border" role="status">
                          <span className="sr-only">{t('query_loading')}</span>
                        </Spinner>
                      </div>
                    ) : (
                                        <div className="table-responsive">

                      <>
                        {/* Display error message if there was an error */}
                        {error ? (
                          <p className="text-danger text-center">{error}</p>
                        ) : (
                          <table id="datatable" className="table table-striped table-bordered">
                            <thead>
                              <tr style={{whiteSpace:"nowrap"}}>
                                <th>{t('order_id')}</th>
                                <th>{t('query_status_label')}</th>
                                <th>{t('created_date')}</th>
                                <th>{t('customer_name')}</th>
                                <th>{t('total_amount')}</th>
                                <th>{t('shipping_amount')}</th>
                                <th>{t('payment_method')}</th>
                                <th>{t('items')}</th>
                                <th>{t('detail')}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* Display a message if no orders are available */}
                              {orders?.length === 0 ? (
                                <tr>
                                  <td colSpan="9" className="text-center">
                                  {t('no_orders_available')}
                                  </td>
                                </tr>
                              ) : (
                                orders?.map((order, idx) => (
                                  <tr key={idx}>
                                    <td>{order?.id}</td>
                                    <td style={{textTransform:"capitalize"}}>{order?.status}</td>
                                    <td>{new Date(order?.date_created).toLocaleString()}</td>
                                    <td>{`${order?.billing.first_name} ${order?.billing.last_name}`}</td>
                                    <td>{order?.currency} {order?.total}</td>
                                    <td>{order?.currency} {order?.shipping_total}</td>
                                    <td>{order?.payment_method_title}</td>
                                    <td>
                                      {order?.line_items.map(item => `${item.name} (${item.quantity} Qty)`).join(', ')}
                                    </td>
                                    <td
                                      style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                      onClick={() => handleViewOrder(order)}
                                    >
                                      {t('view')}
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        )}
                      </>
                  </div>
                    )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Modal for order details */}
      {selectedOrder && (
        <div style={modalStyles}>
          <div style={modalDialogStyles}>
            <button onClick={handleCloseModal} style={closeButtonStyles}>&times;</button>
            <h2>{t('order_details')} - {selectedOrder.id}</h2>
            <p><strong>{t('customer_name')}:</strong> {`${selectedOrder.billing.first_name} ${selectedOrder.billing.last_name}`}</p>
            <p style={{textTransform:"capitalize"}}><strong>{t('query_status_label')}:</strong> {selectedOrder.status}</p>
            <p><strong>{t('total_amount')}:</strong> {selectedOrder?.currency} {selectedOrder.total}</p>
            <p><strong>{t('shipping_amount')}:</strong> {selectedOrder?.currency} {selectedOrder.shipping_total}</p>
            <p><strong>{t('payment_method')}:</strong> {selectedOrder.payment_method_title}</p>
            <p><strong>{t('items')}:</strong></p>
            <ul>
              {selectedOrder.line_items.map((item, idx) => (
                <li key={idx}>{item.name} - {item.quantity} {t('qty')}</li>
              ))}
            </ul>
            <h5>{t('address_details')}</h5>
            <p><strong>{t('name_label')}:</strong> {`${selectedOrder.billing.first_name} ${selectedOrder.billing.last_name}`}</p>
            <p><strong>{t('address')}:</strong> {`${selectedOrder.billing.address_1}, ${selectedOrder.billing.city}, ${selectedOrder.billing.state}, ${selectedOrder.billing.postcode}, ${selectedOrder.billing.country}`}</p>
            <p><strong>{t('email_label')}:</strong> {selectedOrder.billing.email}</p>
            <p><strong>{t('phone_label')}:</strong> {selectedOrder.billing.phone}</p>
            <Button onClick={handleCloseModal} style={{width:"100%"}}
          className="btn btn-primary d-block mt-1 next ">{t('close')}</Button>
          </div>
        </div>
      )}
    </>
  );
};

export default Orders;
